"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.listCompanies = void 0;
const ApiClient_1 = require("../ApiClient");
const listCompanies = () => ApiClient_1.apiClient.get('/api/companies');
exports.listCompanies = listCompanies;
